import { isValid, parseISO } from "date-fns";

const timeOptions: Intl.DateTimeFormatOptions = { hour: "2-digit", minute: "2-digit" };
const dateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric" };
const dateTimeOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};
const fullDateTimeOptions: Intl.DateTimeFormatOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};
const localLanguage: string = navigator.language; // leaving undefined would not always work, see https://bugs.chromium.org/p/chromium/issues/list?q=tolocaledatestring+type%3Abug

export interface FormatDateOptions {
  hideTime?: boolean | null;
  full?: boolean; // overrides the hideTime and the timeOnly
  timeOnly?: boolean; // overrides the hideTime
}

const defaultFormatDateOptions: FormatDateOptions = {
  hideTime: false,
  full: false,
  timeOnly: false,
};
export const formatDateTimeFromISO = (dateTimeISO: string, options: FormatDateOptions = {}): string => {
  const formatDateOptions: FormatDateOptions = {
    ...defaultFormatDateOptions,
    ...options,
  };

  try {
    const date: Date = parseISO(dateTimeISO);

    let options;

    if (formatDateOptions.full) {
      options = fullDateTimeOptions;
    } else if (formatDateOptions.timeOnly) {
      options = timeOptions;
    } else if (formatDateOptions.hideTime) {
      options = dateOptions;
    } else {
      options = dateTimeOptions;
    }

    return isValid(date) ? date.toLocaleString(localLanguage, options) : dateTimeISO;
  } catch {
    return dateTimeISO;
  }
};

export const parseDateTimeToISO = (dateTimeAsString: string): string | null => {
  if (!dateTimeAsString?.trim()) {
    return null;
  }
  const date = new Date(dateTimeAsString);
  return isValid(date) ? date.toISOString() : dateTimeAsString;
};

export const parseDateToISO = (dateTimeAsString: string): string | null => {
  if (!dateTimeAsString?.trim()) {
    return null;
  }
  const date = new Date(dateTimeAsString);
  if (isValid(date)) {
    // we need to keep the offset so that the date corresponds to the local date, before removing the time and timezone information
    const isoDateTimeWithTZOffset = new Date(date.getTime() - date.getTimezoneOffset() * 60_000).toISOString();
    return removeTimeFromISOFormat(isoDateTimeWithTZOffset);
  }
  return dateTimeAsString;
};

export const removeTimeFromISOFormat = (dateTimeISO: string | undefined | null): string | null => {
  if (!dateTimeISO?.trim()) {
    return null;
  }

  return dateTimeISO.slice(0, 10);
};

export const isDateTimeISOFormat = (dateTimeAsString?: string | null): boolean => {
  try {
    if (typeof dateTimeAsString === "string") {
      const date = parseISO(dateTimeAsString);
      return isValid(date);
    }

    return false;
  } catch {
    return false;
  }
};
